import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SITE_LINKS } from '../../constants';
import { Icon } from '../../stories/Icon';

export interface ResponsiveMenuProps {
  isVisible?: boolean;
  menuItems?: { title: string; href: string }[];
  onClose?: () => void;
}

export const ResponsiveMenu = ({ isVisible = false, menuItems, onClose }: ResponsiveMenuProps) => {
  const __ = useTranslation().t;

  return (
    <Container isVisible={isVisible}>
      <TopContent>
        <Title>{__('menu')}</Title>
        <CloseIcon onClick={onClose} name="times" />
      </TopContent>
      <MiddleContent>
        <MenuItems>
          {menuItems?.map((item, key) => (
            <Item href={item.href} key={key}>
              {item.title}
            </Item>
          ))}
        </MenuItems>
      </MiddleContent>
      <BottomContent>
        <LogoutButton href={SITE_LINKS.Logout}>Log out</LogoutButton>
      </BottomContent>
    </Container>
  );
};

interface ContainerProps {
  isVisible: boolean;
}

const Container = styled.div<ContainerProps>`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ isVisible }) => (isVisible ? '100%' : '0')};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: 0.5s;
  background-color: ${({ theme }) => theme.colors.white};
`;

const TopContent = styled.div`
  display: flex;
  position: relative;
  height: 32px;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  margin-top: 32px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
`;

const CloseIcon = styled(Icon)`
  position: absolute;
  padding: 8px;
  right: 16px;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.dark};
`;

const MiddleContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.backgroundLight};
`;

const MenuItems = styled.div`
  padding: 8px 24px;
  width: 100%;
`;

const Item = styled.a`
  display: flex;
  width: 100%;
  padding: 16px 8px;
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundDark};
  transition: 0.5s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundLight};
  }
`;

const BottomContent = styled.div`
  display: flex;
  height: 32px;
  margin-top: 16px;
  margin-bottom: 32px;
  background-color: ${({ theme }) => theme.colors.white};
  align-items: center;
  justify-content: center;
`;

const LogoutButton = styled.a`
  font-size: 16px;
`;
